import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

// project import
import GuestGuard from 'utils/route-guard/GuestGuard';

// ==============================|| LAYOUT - AUTH ||============================== //

const AuthLayout = () => {
  // Check if in development mode to add top padding for warning bar
  const isProduction = (process.env.REACT_APP_PRODUCTION || '').toUpperCase() === 'TRUE';

  return (
    <GuestGuard>
      <Box sx={{ paddingTop: isProduction ? 0 : '20px' }}>
        <Outlet />
      </Box>
    </GuestGuard>
  );
};

export default AuthLayout;
